import { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Container from './MasonryContainer';
import Styles from './UserMasonry.module.scss';

const UserMasonry = ({ users, bottom, className, childClassName }) => {
  const [isMobile, setIsMobile] = useState(false);
  /**
   * Define if isMobile is mobile
   */
  function setSliderType() {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 599) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }
  }

  useEffect(() => {
    window.addEventListener('resize', setSliderType);
    setSliderType();
    return function removeListener() {
      window.removeEventListener('resize', setSliderType);
    };
  }, []);

  return (
    <div className={classNames(Styles.container, className)}>
      <Container className={childClassName} items={users} isMobile={isMobile} bottom={bottom} />
    </div>
  );
};

UserMasonry.propTypes = {
  users: PropTypes.array,
  bottom: PropTypes.bool,
};

export default UserMasonry;
